module.exports = __webpack_public_path__ + "img/melvid-cadastro-despesa.9bf47ab4.png";